import SelfView from 'js/mentions/self_view/index';
import PublicView from 'js/mentions/public_view/index';
import { MentionsCardsContainer } from 'js/mentions/components/MentionsCardContainer';
import { MentionsPostClaimToast } from 'js/mentions/KiiMatching/MentionsPostClaimToast';
import registerForRails from 'js/utils/registerForRails';

import '../stylesheets/mentions.scss';

registerForRails(
  {
    MentionsCardsContainer,
    Mentions: SelfView,
    MentionsPostClaimToast,
    PublicMentions: PublicView,
  },
  ['js/mentions'],
);
